import { createPostCall } from 'utils'
import logger from 'utils/logger-aws'

export const fetchFormstackData = async (formID: string): Promise<any> => {
  const formStackApiUrl = process.env.NEXT_PUBLIC_FORMSTACK_API_URL

  if (!formStackApiUrl || !formID) return null

  const formStackApiEndpoint = `${formStackApiUrl}${formID}`

  const config = {
    method: 'GET',
    headers: {
      //'app-name': 'www.msg.com'
      'Content-Type': 'application/json'
    }
  }

  try {
    const formstackResponse = await fetch(formStackApiEndpoint, config)

    if (!formstackResponse.ok) {
      const message = `[Formstack] - Could not fetch data for form with ID of ${formID} from ${formStackApiEndpoint}.`
      logger.error(message, formstackResponse)
      throw new Error(message)
    }

    const formstackData = await formstackResponse.json()
    return formstackData
  } catch (e) {
    console.error(e)
    logger.error(`[Formstack] - Error fetching from ${formStackApiEndpoint}.`, e)
  }
}

export const createFormstackPostCall = (payload: any, formID: string) => {
  const formStackApiUrl = process.env.NEXT_PUBLIC_FORMSTACK_API_URL

  if (!formStackApiUrl || !formID) return null

  const formStackApiEndpoint = `${formStackApiUrl}${formID}`

  const formstackHeaders = {
    //'app-name': 'www.msg.com',
    'Content-Type': 'application/json'
  }

  const call = createPostCall(payload, formStackApiEndpoint, formstackHeaders as any)
  return call
}
